import { DrawCabinet } from "$src/CGS/domain/dto/article/Cabinet/DrawCabinet";
import { Vector3 } from "three";
import { BaseCabinetShapeGenerator } from "./BaseCabinetShapeGenerator";
import { ICabinetShapeGeneratorParameters } from "./ICabinetShapeGeneratorParameters";
import { CabinetBoxFace } from "./CabinetBoxFace";
import { EFaceElements } from "../../Meshes/EFaceElements";
import { EMaterialSlot } from "../../Meshes/EMaterialSlot";
import { LengthMaths } from "$src/CGS/domain/dto/core/Length/LengthMaths";
import { DrawS20CabinetShape } from "$src/CGS/domain/dto/article/shape/CabinetShapes/DrawS20CabinetShape";
import { EShapeOrientation } from "$src/CGS/domain/dto/article/shape/CabinetShapes/DrawCabinetShape";

export class CabinetS20ShapeGenerator extends BaseCabinetShapeGenerator<DrawS20CabinetShape> {
    
    protected get backDistance(): number {
        return 0.2825;
    }

    constructor(cabinet: DrawCabinet, parameters: ICabinetShapeGeneratorParameters | null) {
        super(cabinet, parameters);
    }

    protected getAnchorOffset(): Vector3 {
        if (this.cabinet.CabinetShape.Orientation === EShapeOrientation.SL ||
            this.cabinet.CabinetShape.Orientation === EShapeOrientation.SR) {
            return new Vector3( LengthMaths.getLengthValue(this.data.Width).meter - this.backDistance, 0, this.backDistance);
        } else {
            return new Vector3( LengthMaths.getLengthValue(this.data.Width).meter * 0.5, 0, this.backDistance);
        }
    }

    public getOutline(): Vector3[] {
        const points: Vector3[] = [
            new Vector3( LengthMaths.getLengthValue(this.data.Width).meter - LengthMaths.getLengthValue(this.data.WC).meter, 0, 0),
            new Vector3( LengthMaths.getLengthValue(this.data.Width).meter, 0, LengthMaths.getLengthValue(this.data.DC).meter),
            new Vector3( LengthMaths.getLengthValue(this.data.Width).meter, 0, LengthMaths.getLengthValue(this.data.Depth).meter),
            new Vector3( LengthMaths.getLengthValue(this.data.Width).meter - LengthMaths.getLengthValue(this.data.W1).meter, 0, LengthMaths.getLengthValue(this.data.Depth).meter),
            new Vector3( LengthMaths.getLengthValue(this.data.Width).meter - LengthMaths.getLengthValue(this.data.W1).meter, 0, LengthMaths.getLengthValue(this.data.D1).meter),
            new Vector3(0, 0, LengthMaths.getLengthValue(this.data.D1).meter),
            new Vector3(0, 0, 0)
        ];

        if ( LengthMaths.getLengthValue(this.data.WC).meter < 0.0001 || LengthMaths.getLengthValue(this.data.DC).meter < 0.0001) {
            points.splice(0, 1);
            points[0] = new Vector3( LengthMaths.getLengthValue(this.data.Width).meter, 0, 0);
        }

        return points;
    }

    public getDefaultFaceDescription(): CabinetBoxFace[] {
        const faces: CabinetBoxFace[] = [
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, -1),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 4),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.SideLeft, 5),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 0),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 1),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.SideRight, 2),
            new CabinetBoxFace(EFaceElements.Full, EMaterialSlot.Box, 3),
        ];

        if ( LengthMaths.getLengthValue(this.data.WC).meter < 0.0001 || LengthMaths.getLengthValue(this.data.DC).meter < 0.0001) {
            faces.splice(0, 1);
        }
        return faces;
    }
}
